import { z } from "zod";
import { emailValidator } from "../../../lib/validator/email";
import { getNameValidator } from "../../../lib/validator/name";
import { passwordValidator } from "../../../lib/validator/password";
import { featureFlag } from "../../../lib/featureFlags/featureFlags";

export const SignupFormSchema = z.object({
  firstName: getNameValidator("First name"),
  lastName: getNameValidator("Last name"),
  email: emailValidator,
  password: passwordValidator,
  ...(featureFlag("marketingOptIn") && { marketingPreferences: z.boolean() }),
});

export type SignupFormSchemaType = z.infer<typeof SignupFormSchema>;
